import { Component } from "react"
import PropTypes from "prop-types"

export default class TriggerForm extends Component {
  constructor(props) {
    super(props)
    this.onTriggerType = this.onTriggerType.bind(this)
    this.onFeedUrlSet = this.onFeedUrlSet.bind(this)
    this.onSlugSet = this.onSlugSet.bind(this)
    const trigger_type =
      props.feed_url && props.feed_url.length > 0 ? "feed" : "protocol"
    this.state = {
      trigger_type,
      feed_url: props.feed_url,
      slug: props.slug,
      error: props.error,
      selected: false,
    }
  }

  componentDidUpdate() {
    // Focus element once the user has toggled the radio
    if (this.state.selected) {
      this.endpointInput.focus()
    }
  }

  onTriggerType(event) {
    this.setState({
      trigger_type: event.target.value,
      error: "",
      selected: true,
    })
  }

  onFeedUrlSet(event) {
    this.setState({
      feed_url: event.target.value,
    })
  }

  onSlugSet(event) {
    this.setState({
      slug: event.target.value,
    })
  }

  render() {
    return (
      <div>
        <div className="field">
          <div className="radio input">
            <input
              type="radio"
              value={"protocol"}
              checked={this.state.trigger_type == "protocol"}
              onChange={this.onTriggerType}
              name="endpoint_type"
              id="endpoint_type_api"
            />
            <label htmlFor="endpoint_type_api">API</label>
          </div>
        </div>

        <div className="field">
          <div className="radio input">
            <input
              type="radio"
              value={"feed"}
              checked={this.state.trigger_type == "feed"}
              onChange={this.onTriggerType}
              name="endpoint_type"
              id="endpoint_type_feed"
            />
            <label htmlFor="endpoint_type_feed">Feed (RSS or Atom)</label>
          </div>
        </div>

        {this.state.error ? (
          <ul className="inline-errors">
            <li>{this.state.error}</li>
          </ul>
        ) : null}

        <div className="field">
          {this.state.trigger_type == "protocol" ? (
            <div>
              <div className="input-group">
                <span className="input-group-addon">
                  {this.props.api_url_prefix}
                </span>
                <input
                  required="required"
                  minLength="4"
                  pattern={this.props.slugValidationPattern}
                  className="input-group-input"
                  type="text"
                  name="partner_trigger[slug]"
                  id="partner_trigger_slug"
                  value={this.state.slug}
                  onChange={this.onSlugSet}
                  ref={input => {
                    this.endpointInput = input
                  }}
                />
              </div>
              <p className="note">
                <p>
                  API endpoint for this trigger. Must be in snake_case and begin
                  with a letter.
                </p>
                <p>
                  To ensure a great Applet experience for your users, triggers
                  must use{" "}
                  <a
                    href={this.props.realtimeApiUrl}
                    className="open-in-new link-inline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    the Realtime API
                  </a>
                </p>
              </p>
            </div>
          ) : (
            <div className="input">
              <input
                required="required"
                type="url"
                name="partner_trigger[feed_url]"
                id="partner_trigger_feed_url"
                value={this.state.feed_url}
                onChange={this.onFeedUrlSet}
                ref={input => {
                  this.endpointInput = input
                }}
                placeholder="http://www.spc.noaa.gov/products/spcwwrss.xml"
              />
              <p className="note">
                Any valid RSS or Atom feed URL. For feed requirements,{" "}
                <a
                  href="https://help.ifttt.com/hc/en-us/articles/115010396768-My-RSS-feed-is-not-working-correctly"
                  className="open-in-new link-inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  visit the help page
                </a>
              </p>
            </div>
          )}
        </div>
      </div>
    )
  }
}

TriggerForm.propTypes = {
  trigger_type: PropTypes.string,
  api_url_prefix: PropTypes.string,
  realtimeApiUrl: PropTypes.string,
  slug: PropTypes.string,
  feed_url: PropTypes.string,
  error: PropTypes.string,
  slugValidationPattern: PropTypes.string,
}
